export default "/assets/images/technology-graph-05.svg?00f55ac2888d9ad3ac155da4542b0a65";